import "regenerator-runtime/runtime"
import _ from "lodash"
import { createClient } from "graphql-ws"
import { RelayNetworkLayer, urlMiddleware, loggerMiddleware, retryMiddleware } from "react-relay-network-modern"
import { Environment, RecordSource, Store, Observable } from "relay-runtime"
import { resolveGraphqlApiPath, resolveGraphqlSubscriptionPath } from "./resolveApiPath"

const NODE_ENV = process.env.NODE_ENV

let cachedPayload
let cachedSignedContext
let cachedUrl
let cachedEnvironment

// Function to get the sessionJWT from cookies


const setupSubscription = ({
  operation,
  variables,
  cache,
  payload,
  signedContext,
  session
}) => {
  // console.log("payload", payload)
  // console.log("signedContext", signedContext)
  const wsClient = createClient({
    // Thunk, not a constant: resolved when the socket is (re)opened in the
    // browser, so the host-based mapping sees the real window.location.host.
    url: () => resolveGraphqlSubscriptionPath(),
    connectionParams: () => {
      return {
        payload,
        signedContext,
        session
      }
    }
  })
  return Observable.create((sink) => {
    return wsClient.subscribe(
      {
        operationName: operation.name,
        query: operation.text,
        variables,
      },
      sink,
    )
  })
}

export const RelayEnvironment = ({
  payload,
  signedContext,
  session
} = {}, options = {}) => {
  const headers = {}

  // Include the session JWT in the headers for every request

  if (session) {
    headers['Authorization'] = `Bearer ${session}`
  }

  if (!_.isEmpty(payload) && signedContext) {
    headers["X-Woztell-Payload"] = JSON.stringify(payload)
    headers["X-Woztell-SignedContext"] = signedContext
  }
  // Part of the cache key: an environment built during the react-snap
  // prerender (or before the host mapping resolved) must not be reused for the
  // real host.
  const url = resolveGraphqlApiPath()

  if (_.isEqual(payload, cachedPayload) && cachedSignedContext === signedContext && cachedUrl === url && cachedEnvironment) {
    return cachedEnvironment
  }
  cachedPayload = payload
  cachedSignedContext = signedContext
  cachedUrl = url
  const newEnv = new Environment({
    network: new RelayNetworkLayer([
      urlMiddleware({
        // Thunk, so every request re-resolves against the live host.
        url: () => resolveGraphqlApiPath(),
        headers,
        credentials: "include"
      }),
      navigator.userAgent !== "ReactSnap" ? retryMiddleware({
        fetchTimeout: 45000,
        retryDelays: (attempt) => {
          if (attempt > 10) {
            return false
          }
          return Math.pow(2, attempt + 4) * 100
        }
      }) : null,
      NODE_ENV === "production" ? null : loggerMiddleware()
    ], {
      subscribeFn: (operation, variables, cache) => {
        return setupSubscription({ operation, variables, cache, payload, signedContext, session } )
      }
    }),
    store: new Store(new RecordSource()),
  })
  cachedEnvironment = newEnv
  return cachedEnvironment
}
